<template>
  <div :class="['c4d-si-collection', layoutStyleClass, gridColumnClass, productPosition]">
    <div class="__banners" :style="[gridWrapperGutter]">
      <div
        class="__banner"
        v-for="(image, indexBanner) in listBanners"
        :key="indexBanner"
        :style="[gridItemWidth, gridColumnGutter, gridRowMargin]"
      >
        <img :src="image.url" />
        <div
          :class="['__product', actives.indexOf(indexBanner + '-' + indexProduct) > -1 ? 'active' : '']"
          v-for="(product, indexProduct) in image.products"
          v-on:click="onClickProduct"
          :key="indexProduct"
          :data-id="product.id"
          :style="[
            typeof product.position != 'undefined' ? {top: product.position.top, left: product.position.left} : {}
          ]"
        >
          <ClickIcon :product="product" :isHoverItems="isHoverItems" :click-index="indexBanner + '-' + indexProduct" :index="indexProduct + 1" />
          <template v-if="typeof products[product.id] != 'undefined'">
            <ProductInfo :product="products[product.id]" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductInfo from "./components/ProductInfo";
import ClickIcon from "./components/ClickIcon";
export default {
  name: "Front",
  components: {
    ClickIcon,
    ProductInfo
  },
  data: function() {
    return {
      products: [],
      actives: [],
      isHoverItems: []
    };
  },
  computed: {
    layoutStyleClass: function() {
      return "layout-" + this.$store.state.front.settings.basicLayoutStyle;
    },
    gridColumnClass: function() {
      if (this.$store.state.front.settings.basicLayoutStyle == "grid") {
        return "grid-columns-" + this.$store.state.front.settings.gridColumn;
      }
      return "";
    },
    gridRowMargin: function() {
      if (this.$store.state.front.settings.basicLayoutStyle == "grid") {
        return {
          marginBottom: this.$store.state.front.settings.gridRowMargin + "px"
        };
      }
      return "";
    },
    gridColumnGutter: function() {
      if (this.$store.state.front.settings.basicLayoutStyle == "grid") {
        return {
          paddingRight: this.$store.state.front.settings.gridGutter + "px",
          paddingLeft: this.$store.state.front.settings.gridGutter + "px"
        };
      }
      return "";
    },
    gridWrapperGutter: function() {
      if (this.$store.state.front.settings.basicLayoutStyle == "grid") {
        return {
          marginRight: "-" + this.$store.state.front.settings.gridGutter + "px",
          marginLeft: "-" + this.$store.state.front.settings.gridGutter + "px"
        };
      }
      return "";
    },
    gridItemWidth: function() {
      if (this.$store.state.front.settings.basicLayoutStyle == "grid") {
        return {
          width: 100 / this.$store.state.front.settings.gridColumn + "%"
        };
      }
      return "";
    },
    listBanners: function() {
      return this.$store.state.front.collection.images;
    },
    productPosition: function() {
      return (
        "product-position-" + this.$store.state.front.settings.clickIconPosition
      );
    }
  },
  methods: {
    onClickProduct: function(event) {
      if (!this.$store.state.front.settings.clickIconKeepOpenOnClick)
        return false;
      let index = jQuery(event.target).attr("click-index");
      
      if (this.actives.indexOf(index) < 0) {
        this.actives.push(index); // = [...this.actives, index];
      } else {
        this.actives.splice(this.actives.indexOf(index), 1);
      }
    }
  },
  beforeCreate: async function() {
    let that = this;
    let pIds = that.$store.state.front.collection.products.map(
      product => product.id
    );
    var url = c4dWooSiOptions.ajax_url + "?";
    var data = decodeURIComponent(
      jQuery.param({
        action: "c4d_si_json_search_product_by_ids",
        pids: pIds
      })
    );
    let response = await fetch(url + data)
      .then(res => res.json())
      .then(data => {
        that.products = data;
      });
  },
  mounted: function() {
    let that = this;
    let el = this.$el;
    let options = that.$store.state.front.settings;
    
    if (this.$store.state.front.settings.basicLayoutStyle == "slider") {
      jQuery(document).ready(function() {
        var slider = jQuery(el).find(".__banners");
        slider.slick({
          dots: options.sliderNavigation,
          infinite: false,
          speed: 300,
          slidesToShow: options.slidertoShow,
          slidesToScroll: options.sliderTopScroll,
          autoplay: options.sliderAutoplay,
          autoplaySpeed: options.sliderPlaySpeed,
          arrows: options.sliderNextPrev,
          prevArrow: options.sliderPrevButton,
          nextArrow: options.sliderNextButton,
          pauseOnHover: true,
          pauseOnDotsHover: true,
          mobileFirst: true
        });
      });
    }
  },
  beforeUpdated: function() {
    console.log(this);
  },
  updated: function() {
    console.log(this);
  }
};
</script>
<style lang="scss" scoped>
.c4d-si-collection {
  .__banner {
    position: relative;
    .__product {
      position: absolute;
      width: 40px;
      height: 40px;
    }
  }
  &.default-style {
    .__banner {
      margin: auto auto 20px;
    }
  }
  &.layout-grid {
    .__banners {
      display: flex;
      flex-wrap: wrap;
      margin: auto -10px;
      justify-items: flex-start;
    }
    .__banner {
      margin: auto 0px 20px;
      padding: 0 10px;
    }
  }
  &.layout-slider {
    .__banners {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      margin: auto -10px;
      justify-items: flex-start;
      overflow: hidden;
    }
    .__banner {
      margin: 0px;
      padding: 0 10px;
      z-index: 1;
      &:nth-child(n + 2) {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
    }
    .slick-prev {
      left: 30px;
    }
    .slick-next {
      right: 30px;
    }
  }
}
</style>
<style lang="scss">
.c4d-si-collection {
  &.layout-slider {
    .slick-prev {
      left: 30px;
      z-index: 999;
    }
    .slick-next {
      right: 30px;
      z-index: 999;
    }
    .slick-dots {
      position: relative;
      bottom: 0;
      margin: auto;
      padding: 0;
      li {
        margin: auto;
        padding: 0;
      }
    }
  }
}
</style>

